import React, { useState } from 'react';
import { User, Lock, Save, Loader2, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function AdminProfile() {
  const { user, refresh } = useAuth();
  const [username, setUsername] = useState(user?.username || '');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [savingU, setSavingU] = useState(false);
  const [savingP, setSavingP] = useState(false);

  const saveUsername = async () => {
    const u = username.trim().toLowerCase();
    if (!/^[a-zA-Z0-9._-]{2,64}$/.test(u)) return toast.error('Username non valido (2-64 caratteri, no spazi/simboli)');
    if (u === user.username) return toast.info('Nessuna modifica');
    setSavingU(true);
    try {
      await api.put('/users/me/username', { username: u });
      toast.success('Username aggiornato');
      await refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Errore');
    } finally { setSavingU(false); }
  };

  const savePassword = async () => {
    if (password.length < 6) return toast.error('Minimo 6 caratteri');
    if (password !== password2) return toast.error('Le password non coincidono');
    setSavingP(true);
    try {
      const { data } = await api.put('/users/me/password', { password });
      if (data.token) localStorage.setItem('gtc_token', data.token);
      toast.success('Password aggiornata (altre sessioni disconnesse)');
      setPassword(''); setPassword2('');
      await refresh();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Errore');
    } finally { setSavingP(false); }
  };

  return (
    <div className="card-surface p-4 space-y-4" data-testid="admin-profile-section">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[var(--gold-soft)] border border-[var(--gold)]/40 flex items-center justify-center">
          <ShieldCheck className="w-5 h-5 text-[var(--gold)]" />
        </div>
        <div className="flex-1">
          <div className="font-heading font-medium">Il mio profilo admin</div>
          <div className="text-xs text-white/60">Modifica username e password del tuo account.</div>
        </div>
      </div>

      <div className="space-y-2">
        <label className="text-[10px] uppercase tracking-widest text-white/50 flex items-center gap-2"><User className="w-3 h-3" /> Username</label>
        <div className="flex gap-2">
          <input
            data-testid="admin-profile-username"
            className="input-gold flex-1"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <button data-testid="admin-profile-username-save" onClick={saveUsername} disabled={savingU} className="btn-gold px-4 flex items-center gap-2">
            {savingU ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          </button>
        </div>
      </div>

      <div className="space-y-2 border-t border-[var(--border-subtle)] pt-3">
        <label className="text-[10px] uppercase tracking-widest text-white/50 flex items-center gap-2"><Lock className="w-3 h-3" /> Nuova password</label>
        <input
          data-testid="admin-profile-password"
          type="password"
          className="input-gold"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Min 6 caratteri"
        />
        <input
          data-testid="admin-profile-password2"
          type="password"
          className="input-gold"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
          placeholder="Ripeti password"
        />
        <button data-testid="admin-profile-password-save" onClick={savePassword} disabled={savingP || !password} className="btn-gold w-full py-2.5 flex items-center justify-center gap-2">
          {savingP ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4" /> Aggiorna password</>}
        </button>
      </div>
    </div>
  );
}
